module["exports"] = [
  "(####) ######",
  "##########",
  "06########",
  "06 #### ####"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/nl/phone_number/formats.js
// module id = 1419
// module chunks = 0